import gql from 'graphql-tag';

const PAID_SEARCH_PACING_GOOGLE = gql`
  query paidSearchPacingGoogle(
    $orgId: String!
    $advertiserIds: [String!]!
    $date: String
    $status: String
  ) {
    getPaidSearchPacingGoogle(
      orgId: $orgId
      advertiserIds: $advertiserIds
      date: $date
      status: $status
    ) {
      id
      startDate
      endDate
      overallPacingData {
        date
        dayOfMonth
        dayInMonth
        impressions
        clicks
        spend
        pace
        dailyRemainSpend
        ctr
        cpc
        targetPacing
      }
      config {
        id
        monthlyBudget
      }
      org {
        id
        name
      }
    }
  }
`;

export default PAID_SEARCH_PACING_GOOGLE;
